import React, { useState } from "react"; 
import { Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { useTheme } from "../ThemeContext";
import { FaUsers } from "react-icons/fa";

import WidgetCreator from "./WidgetCreator";

import "./LDomainScan.css";
import PastScans_online from "./PastScans_online"; 

const LWidget = () => {
  const { isDarkMode } = useTheme();
  const [active, setActive] = useState("widget");

  return (
    <Card className={`sub-tab-card ${isDarkMode ? "bg-dark" : "bg-light"}`}>
      {/* Custom Sub-Tab Header */}
      <div className="pill-tabs">
        <motion.button
          className={`pill-tab ${active === "widget" ? "active" : ""}`}
          onClick={() => setActive("widget")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          🧩 Widget
        </motion.button>

        <motion.button
          className={`pill-tab ${active === "leads" ? "active" : ""}`}
          onClick={() => setActive("leads")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
         <FaUsers size={24} color="#10b981" />
         <span> Leads</span>
        </motion.button>
      </div>

      {/* Content Area */}
      <div className={`pill-content ${isDarkMode ? "bg-dark" : "bg-light"}`}>
        <motion.div
          animate={{ opacity: active === "leads" ? 1 : 0, y: active === "leads" ? 0 : 10 }}
          style={{ display: active === "leads" ? "block" : "none" }}
          transition={{ duration: 0.25 }}
        >
          <PastScans_online />
        </motion.div>


        <motion.div
          animate={{ opacity: active === "widget" ? 1 : 0, y: active === "widget" ? 0 : 10 }}
          style={{ display: active === "widget" ? "block" : "none" }}
          transition={{ duration: 0.25 }}
        >
          <WidgetCreator />
        </motion.div>
      </div>
    </Card>
  );
};

export default LWidget;
